import Image from "components/base/Image";
import { MotionBox, staggeredAppear, appearBelow } from "utils/motion";
import { Box, Flex, Grid } from "@chakra-ui/react";

export default function GallerySection({ images = [] }) {
  const [mainImage, ...secondaryImages] = images;

  return (
    <Box bg="black.900" width="100%">
      <Flex justify="center" py={["xl", null, "xxxl"]} px={[6, null, 20]}>
        <MotionBox
          width="100%"
          maxWidth="xl"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={staggeredAppear}
        >
          {/* Large image */}
          {mainImage && (
            <MotionBox variants={appearBelow} mb={[4, null, 5]}>
              <Box
                position="relative"
                width="100%"
                height={["280px", null, "690px"]}
              >
                <Image
                  src={mainImage.src}
                  alt={mainImage.alt}
                  objectFit="cover"
                  style={{ position: "absolute" }}
                />
              </Box>
            </MotionBox>
          )}

          {/* Smaller images side by side */}
          {secondaryImages.length > 0 && (
            <Grid
              templateColumns={[
                "1fr",
                null,
                `repeat(${secondaryImages.length}, 1fr)`,
              ]}
              gap={[4, null, 5]}
            >
              {secondaryImages.map((img, index) => (
                <MotionBox key={index} variants={appearBelow}>
                  <Box
                    position="relative"
                    width="100%"
                    height={["200px", null, "380px"]}
                  >
                    <Image
                      src={img.src}
                      alt={img.alt}
                      objectFit="cover"
                      style={{ position: "absolute" }}
                    />
                  </Box>
                </MotionBox>
              ))}
            </Grid>
          )}
        </MotionBox>
      </Flex>
    </Box>
  );
}
